import { useContext } from "react"
import { PageElementContext, WebEditorContext } from "../../../../../contexts"
import { FormTextInput } from "../../../../../components/Form/FormTextInput"
import { FormNumber } from "../../../../../components/Form/FormNumber"
import { FormSelect } from "../../../../../components/Form/FormSelect"
import { FormCheckbox } from "../../../../../components/Form/FormCheckbox"
import { FormDate } from "../../../../../components/Form/FormDate"
import _ from "lodash"
import { format } from 'date-fns';
import * as Constants from "../../../../../utils/constants"
import {
    resources,
    translations,
} from "../../../../../translations/translationsConstants";
import { useTranslation } from "react-i18next";

export default function DxmlInputField({ editorInputField, hasOneInputFieldInParagraph }) {
    return (
        <InputFieldComponent editorInputField={editorInputField} hasOneInputFieldInParagraph={hasOneInputFieldInParagraph} ></InputFieldComponent>
    )
}

function InputFieldComponent({ editorInputField, hasOneInputFieldInParagraph }) {
    const { editorDisabled, onInputFieldChange, autoSaveEditorFile, formikValuesRef, inputFieldErrors, editorFileRef, isLoading, inputFieldTouchedRef } = useContext(WebEditorContext);
    let value = formikValuesRef.current[editorInputField.Id];
    const error = inputFieldErrors[editorInputField.Id];
    const touched = inputFieldTouchedRef.current[editorInputField.Id];
    const style = editorInputField.ReactCssStyle && typeof editorInputField.ReactCssStyle === 'object' ? _.cloneDeep(editorInputField.ReactCssStyle) : {};
    if (editorInputField.InputFieldType !== Constants.inputFieldType.checkbox && hasOneInputFieldInParagraph) {
        style.width = "100%";
    }
    const { handleContextMenu: handlePageElementContextMenu } = useContext(PageElementContext) || {};
    const { t: tc } = useTranslation([resources.common]);

    const handleContextMenu = (e) => {
        if (!handlePageElementContextMenu)
            return;

        e.preventDefault();

        const input = e.target;

        const start = input.selectionStart;
        const end = input.selectionEnd;

        e.extraMenuItems = null;
        e.selectedElement = { type: editorInputField.Type, elementRef: editorInputField, range: { index: start, length: (end - start) } };
    }

    const handleChange = async (e) => {
        onInputFieldChange(e);
        formikValuesRef.current[editorInputField.Id] = editorInputField.InputFieldType === Constants.inputFieldType.checkbox ? e.target.checked : e.target.value;
        inputFieldTouchedRef.current[editorInputField.Id] = true;

        if (editorInputField.VarName && editorFileRef.current.EditorInputFields) {
            let editorInputFieldWithSameVarName = editorFileRef.current.EditorInputFields.filter(x => x.VarName === editorInputField.VarName);
            if (editorInputFieldWithSameVarName) {
                editorInputFieldWithSameVarName.forEach(x => {
                    onInputFieldChange({
                        target: {
                            name: x.Id,
                            value: e.target.value,
                        }
                    });
                    formikValuesRef.current[x.Id] = editorInputField.InputFieldType === Constants.inputFieldType.checkbox ? e.target.checked : e.target.value;
                });
            }
        }

        autoSaveEditorFile();
    }

    if (editorInputField.InputFieldType === Constants.inputFieldType.text) {
        return <FormTextInput
            id={editorInputField.Id}
            style={style}
            name={editorInputField.Id}
            title={editorInputField.DxmlAttributes?.Label}
            value={value}
            disabled={editorDisabled}
            onChange={handleChange}
            onContextMenu={handleContextMenu}
            error={error}
            touched={touched}
            isLoading={isLoading}
            minlength={editorInputField.ValidationRule?.MinLength}
            maxlength={editorInputField.ValidationRule?.MaxLength}
        />
    } else if (editorInputField.InputFieldType === Constants.inputFieldType.decimal || editorInputField.InputFieldType === Constants.inputFieldType.integer) {
        return <FormTextInput
            id={editorInputField.Id}
            style={style}
            name={editorInputField.Id}
            title={editorInputField.DxmlAttributes?.Label}
            value={value}
            disabled={editorDisabled}
            onChange={handleChange}
            onContextMenu={handleContextMenu}
            error={error}
            touched={touched}
            isLoading={isLoading}
            minlength={editorInputField.ValidationRule?.MinLength}
            maxlength={editorInputField.ValidationRule?.MaxLength}
        />
    } else if (editorInputField.InputFieldType === Constants.inputFieldType.checkbox) {
        if (value === undefined) {
            value = false;
        }
        return <FormCheckbox
            id={editorInputField.Id}
            style={style}
            name={editorInputField.Id}
            label={editorInputField.DxmlAttributes?.Label}
            value={value}
            disabled={editorDisabled}
            onChange={handleChange}
            error={error}
            touched={touched}
            isLoading={isLoading}
        />
    } else if (editorInputField.InputFieldType === Constants.inputFieldType.select) {
        const options = editorInputField.Options.map(option => { return { name: option.Name, value: option.Value } })
        if (editorInputField.ValidationRule?.NotEmpty) {
            options.unshift({ name: tc(translations.common.selectenoption), value: "", disabled: true, hidden: true })
        } else {
            options.unshift({ name: tc(translations.common.none), value: "" })
        }
        return <FormSelect
            id={editorInputField.Id}
            style={style}
            name={editorInputField.Id}
            label={editorInputField.DxmlAttributes?.Label}
            value={value}
            disabled={editorDisabled}
            onChange={handleChange}
            error={error}
            options={options}
            touched={touched}
            isLoading={isLoading}
        />
    } else if (editorInputField.InputFieldType === Constants.inputFieldType.date) {
        let dateText = '';
        if (!value) {
            dateText = '';
        } else if (_.isString(value)) {
            let dateValue = new Date(value);
            const dateFormat = "yyyy-MM-dd";
            dateText = format(dateValue, dateFormat);
        }

        return <FormDate
            id={editorInputField.Id}
            style={style}
            name={editorInputField.Id}
            label={editorInputField.DxmlAttributes?.Label}
            value={dateText}
            disabled={editorDisabled}
            onChange={handleChange}
            error={error}
            touched={touched}
            isLoading={isLoading}
        />
    } else {
        return <></>
    }
}